import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch, faUndo, faList, faClipboardList,
    faEye, faFileExcel, faChevronDown, faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx'; // Import SheetJS

class Editar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pacientes: [],
            filteredPacientes: [],
            expandedRows: new Set(),
            filters: {
                cedula: '',
                nombre: '',
                apellido: '',
                eps: ''
            }
        };
    }

    componentDidMount() {
        this.cargarPacientesActivos();
    }

    cargarPacientesActivos = async () => {
        this.setState({ loading: true });
        try {
            const response = await authAxios.post("/master/pacientesactivos");
            if (response.data.Status) {
                const pacientes = response.data.pacientes;
                this.setState({
                    pacientes: pacientes,
                    filteredPacientes: pacientes,
                    loading: false
                });
            } else {
                Swal.fire("Error", "No se pudieron cargar los pacientes", "error");
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error de conexión con el servidor", "error");
            this.setState({ loading: false });
        }
    };

    handleFilterChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: value
            }
        }), () => this.applyFilters());
    };

    applyFilters = () => {
        const { pacientes, filters } = this.state;
        const { cedula, nombre, apellido, eps } = filters;

        let filtered = [...pacientes];

        if (cedula.trim() !== '') {
            filtered = filtered.filter(p => p.cedula.toString().includes(cedula.trim()));
        }
        if (nombre.trim() !== '') {
            filtered = filtered.filter(p => p.nombre.toLowerCase().includes(nombre.trim().toLowerCase()));
        }
        if (apellido.trim() !== '') {
            filtered = filtered.filter(p => p.apellido.toLowerCase().includes(apellido.trim().toLowerCase()));
        }
        if (eps.trim() !== '') {
            filtered = filtered.filter(p => p.eps.toLowerCase().includes(eps.trim().toLowerCase()));
        }

        this.setState({ filteredPacientes: filtered });
    };

    resetFilters = () => {
        this.setState({
            filters: {
                cedula: '',
                nombre: '',
                apellido: '',
                eps: ''
            }
        }, () => this.applyFilters());
    };

    toggleOrders = (pacienteId) => {
        this.setState(prevState => {
            const newExpanded = new Set(prevState.expandedRows);
            if (newExpanded.has(pacienteId)) {
                newExpanded.delete(pacienteId);
            } else {
                newExpanded.add(pacienteId);
            }
            return { expandedRows: newExpanded };
        });
    };

    verOrden = (id, tabla) => {
        window.localStorage.setItem("Archivo", id);
        window.localStorage.setItem("TablaId", tabla);
    };

    exportToExcel = () => {
        const { filteredPacientes } = this.state;
        if (filteredPacientes.length === 0) {
            Swal.fire("Sin datos", "No hay pacientes para exportar", "warning");
            return;
        }

        // Prepare data for Excel (flattened, one row per patient)
        const rows = filteredPacientes.map(p => ({
            ID: p.id,
            Nombre: p.nombre,
            Apellido: p.apellido,
            Cédula: p.cedula,
            Teléfono: p.telefono || '',
            Email: p.email || '',
            EPS: p.eps,
            'Órdenes Activas (IDs)': p.ordenes_activas?.map(o => o.id).join(', ') || ''
        }));

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(rows);
        // Auto-size columns (optional, simple approach)
        const colWidths = [];
        Object.keys(rows[0]).forEach(key => {
            const maxLen = Math.max(key.length, ...rows.map(r => String(r[key] || '').length));
            colWidths.push({ wch: maxLen + 2 });
        });
        ws['!cols'] = colWidths;

        // Create workbook and append worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Pacientes Activos');

        // Export file
        XLSX.writeFile(wb, `pacientes_activos_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`);

        Swal.fire("Exportado", "Archivo Excel generado correctamente", "success");
    };

    renderOrdenes = (ordenes) => {
        if (!ordenes || ordenes.length === 0) {
            return <div className="text-muted small">Sin órdenes activas</div>;
        }
        return (
            <table className="table table-sm table-bordered mb-0" style={{ backgroundColor: '#f9f9f9' }}>
                <thead className="thead-light">
                    <tr>
                        <th>ID Orden</th>
                        <th>Archivo</th>
                        <th>Autorización</th>
                        <th>Fecha Inicio</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {ordenes.map(orden => (
                        <tr key={orden.id}>
                            <td>{orden.id}</td>
                            <td>{orden.archivo}</td>
                            <td>{orden.autorizacion}</td>
                            <td>{orden.fecha_inicio}</td>
                            <td>
                                <Link
                                    className="btn btn-success btn-sm"
                                    to="../pages/orden/Dubai"
                                    onClick={() => this.verOrden(orden.id, orden.archivo)}
                                >
                                    <FontAwesomeIcon icon={faEye} /> Ver
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    render() {
        const { loading, filteredPacientes, filters, expandedRows } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REPORTE DE PACIENTES ACTIVOS (CON ÓRDENES ACTIVAS)</b>
                                <div className="float-right">
                                    <button className="btn btn-success btn-sm" onClick={this.exportToExcel}>
                                        <FontAwesomeIcon icon={faFileExcel} /> Exportar a Excel
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* Filtros */}
                                <div className="row mb-4">
                                    <div className="col-md-3">
                                        <label>Cédula</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="cedula"
                                            value={filters.cedula}
                                            onChange={this.handleFilterChange}
                                            placeholder="Número de cédula"
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Nombre</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="nombre"
                                            value={filters.nombre}
                                            onChange={this.handleFilterChange}
                                            placeholder="Nombre"
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Apellido</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="apellido"
                                            value={filters.apellido}
                                            onChange={this.handleFilterChange}
                                            placeholder="Apellido"
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>EPS</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="eps"
                                            value={filters.eps}
                                            onChange={this.handleFilterChange}
                                            placeholder="EPS"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-md-12 text-right">
                                        <button className="btn btn-primary mr-2" onClick={this.applyFilters}>
                                            <FontAwesomeIcon icon={faSearch} /> Filtrar
                                        </button>
                                        <button className="btn btn-secondary" onClick={this.resetFilters}>
                                            <FontAwesomeIcon icon={faUndo} /> Limpiar
                                        </button>
                                    </div>
                                </div>

                                {/* Tabla de pacientes */}
                                {loading ? (
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                        <p>Cargando pacientes activos...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Nombre Completo</th>
                                                    <th>Cédula</th>
                                                    <th>Teléfono</th>
                                                    <th>Email</th>
                                                    <th>EPS</th>
                                                    <th>Órdenes Activas</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredPacientes.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">No se encontraron pacientes</td>
                                                    </tr>
                                                ) : (
                                                    filteredPacientes.map(paciente => (
                                                        <React.Fragment key={paciente.id}>
                                                            <tr>
                                                                <td>{paciente.id}</td>
                                                                <td>{paciente.nombre} {paciente.apellido}</td>
                                                                <td>{paciente.cedula}</td>
                                                                <td>{paciente.telefono || '-'}</td>
                                                                <td>{paciente.email || '-'}</td>
                                                                <td>{paciente.eps}</td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-info"
                                                                        onClick={() => this.toggleOrders(paciente.id)}
                                                                    >
                                                                        <FontAwesomeIcon icon={expandedRows.has(paciente.id) ? faChevronDown : faChevronRight} />
                                                                        {' '}{paciente.ordenes_activas?.length || 0} orden(es)
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            {expandedRows.has(paciente.id) && (
                                                                <tr>
                                                                    <td colSpan="7" style={{ padding: '0 0 20px 0', backgroundColor: '#fcfcfc' }}>
                                                                        <div style={{ margin: '10px' }}>
                                                                            <strong><FontAwesomeIcon icon={faList} /> Detalle de órdenes activas:</strong>
                                                                            <div className="mt-2">
                                                                                {this.renderOrdenes(paciente.ordenes_activas)}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;